import { useQuery } from '@tanstack/react-query';
import { IInventoryOption } from '../../Interfaces/IInventoryOption';
import { customFetcher } from '../useFetch';

//////////////////// InventoryOptions
export const useGeInventoryOptions = () => {
  const { data: inventoryOptions, isLoading: isLoadingInventoryOptions } =
    useQuery<IInventoryOption[]>({
      refetchOnWindowFocus: false,
      queryKey: ['inventoryoption'],
      queryFn: () =>
        customFetcher({
          endpoint: '/inventoryoption',
        }),
    });

  return { inventoryOptions, isLoadingInventoryOptions };
};
